import React from 'react'
import toastr from '@/lib/notifications'
import $ from 'jquery'
import _ from 'underscore'
import { Input } from '@/components/ui/input'
import SubjectResultsPartial from './partial'

class SearchSubjects extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      searching: false,
      value: this.props.value || '',
      results: []
    }

    this.inputRef = React.createRef()
  }

  componentDidMount() {
    this.lazyFetchResults = _.debounce(this.fetchResults, 300)
  }

  onChange = () => {
    const value = this.inputRef.current.value

    this.setState({
      value: value,
      searching: true
    })

    this.props.onChange(value)
    this.lazyFetchResults()
  }

  fetchResults() {
    const params = {
      search: this.state.value,
      country_code: this.props.country_code
    }

    $.ajax({
      url: "/api/sales/subjects",
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      data: params,
      success: (data) => {
        if (this.props.subject_category_name) {
          const filteredResults = _.select(data.items, (item) => {return item.subject_category_name === this.props.subject_category_name})
          this.setState({results: filteredResults})
        }
        else {
          this.setState({results: data.items})
        }
      },
      error: (data) => {
        if (data && data.responseJSON && data.responseJSON.custom_error_message)
          toastr.error(data.responseJSON.custom_error_message)
        else
          toastr.error('something went wrong')
      }
    })
  }

  onResultClick = (result) => {
    this.setState({searching: false, value: result.name, results: []})
    this.props.onSelect(result)

    if (this.props.subject_category_name) {
      this.setState({value: ''})
    }
  }

  highlightInput = (e) => {
    e.target.select()
  }

  render() {
    return (
      <div>
        <Input type="text" name="value" placeholder="e.g. 'Math'" ref={this.inputRef} value={this.state.value} onChange={this.onChange} onClick={this.highlightInput} />
        <ul className="m-0 mt-1 max-h-[220px] list-none overflow-y-auto p-0">
          {this.state.searching ?
            _.map(this.state.results, (result) => {
              return (
                <SubjectResultsPartial key={result.id} result={result} onClick={this.onResultClick}/>
              )
            })
            : null
          }
        </ul>
      </div>
    )
  }
}

export default SearchSubjects
